<template>
    <v-container fluid>
        <v-row style="margin-left:15px;margin-right:15px">
            <route-builder-filters :set-bounds="setBounds"></route-builder-filters>
        </v-row>
        <v-row style="margin-left:15px;margin-right:15px">
            <v-flex>
                <planning-map-view ref="planningMap"></planning-map-view>
            </v-flex>
        </v-row>
    </v-container>
</template>
<script>
    import RouteBuilderFilters from "../../components/planning/FilterBar";
    import PlanningMapView from "../../components/planning/PlanningMap";
    export default {
        components: {
            PlanningMapView,
            RouteBuilderFilters
        },
        methods: {
            setBounds() {
                this.$nextTick(() => {
                    this.$refs.planningMap.setMapBounds()
                })
            }
        }
    }
</script>
